import type { RouteRecordRaw } from "vue-router";

export const settingsRoute: RouteRecordRaw = {
    path: '/settings',
    children: [
        {
            name: 'Chat Settings',
            path: 'chat',
            component: () => import('./chat/ChatPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Idexx Setup',
            path: 'idexx-setup',
            component: () => import('./add-ons/idexx/IdexxSetup.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Call & Text Add-on',
            path: 'addons/twilio',
            component: () => import('./add-ons/twilio/TwilioAddon.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Capacity Management',
            path: 'capacity-management',
            component: () => import('./capacity-management/CapacityManagement.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Clinic Profile',
            path: 'clinic-profile',
            component: () => import('./clinic-profile/ClinicProfile.vue'),
        },
        {
            name: 'E-Lobby Settings',
            path: 'e-lobby',
            component: () => import('./e-lobby/ELobby.vue'),
        },
        {
            name: 'E-Payments',
            path: 'e-payments',
            component: () => import('./e-payments/EPayments.vue'),
        },
        {
            name: 'High Risk Waiver Setup',
            path: 'high-risk-waiver',
            component: () => import('./high-risk-waiver/HighRiskWaiver.vue'),
        },
        {
            name: 'Invoices Settings',
            path: 'invoices',
            component: () => import('./invoices/Invoices.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Medical Record Requests',
            path: 'medical-record',
            component: () => import('./medical-record-requests/MedicalRecordRequests.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Microchips Settings',
            path: 'microchips',
            component: () => import('./microchips/Microchips.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Custom Fields',
            path: 'custom-fields',
            component: () => import('./custom-fields/CustomFields.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Custom Field Groups',
            path: 'custom-fields/groups',
            component: () => import('./custom-fields/groups/CustomFieldGroups.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: `Custom Fields | New`,
            path: 'custom-fields/new',
            component: () => import('./custom-fields/CustomFieldsEdit.vue'),
        },
        {
            name: `Custom Fields | Edit`,
            path: 'custom-fields/edit/:id',
            component: () => import('./custom-fields/CustomFieldsEdit.vue'),
            props: true
        },
        {
            name: 'QuickBooks',
            path: 'quick-books',
            component: () => import('./quick-books/QuickBooks.vue'),
        },
        {
            name: 'Vaccine Setup',
            path: 'vaccine-setup',
            component: () => import('./rabies-tags/RabiesTags.vue'),
        },
        {
            name: 'Vaccine Setup | Create',
            path: 'vaccine-setup/create',
            component: () => import('./rabies-tags/RabiesTagsEdit.vue'),
        },
        {
            name: 'Vaccine Setup | Edit',
            path: 'vaccine-setup/edit/:id',
            component: () => import('./rabies-tags/RabiesTagsEdit.vue'),
            props: true
        },
        {
            name: 'Tags',
            path: 'tags',
            component: () => import('./tags/Tags.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Tax Info',
            path: 'taxes',
            component: () => import('./tax/Tax.vue'),
        },
        {
            name: 'Tax Info | Create',
            path: 'taxes/create',
            component: () => import('./tax/TaxEdit.vue'),
        },
        {
            name: 'Tax Info | Edit',
            path: 'taxes/edit/:id',
            component: () => import('./tax/TaxEdit.vue'),
        },
        {
            name: 'The Vault',
            path: 'vault',
            component: () => import('./vault/Vault.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'VC Custom Pricing',
            path: 'vc-custom-pricing',
            component: () => import('./vc-custom-pricing/VcCustomPricing.vue'),
        },
        {
            name: 'VCP Settings',
            path: 'vcp-settings',
            component: () => import('./vcp/VcpSettings.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Services and Products',
            path: 'services',
            component: () => import('./clinic-items/ClinicItems.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Packages',
            path: 'packages',
            component: () => import('./clinic-items/PackagesPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Packages | Create',
            path: 'packages/create',
            component: () => import('./clinic-items/PackagesEdit.vue'),
        },
        {
            name: 'Packages | Edit',
            path: 'packages/edit/:id',
            component: () => import('./clinic-items/PackagesEdit.vue'),
            props: true
        },
        {
            name: 'Donations Navigation',
            path: 'donations',
            component: () => import('./donations/DonationsNav.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Donation Fees',
            path: 'donations/fees',
            component: () => import('./donations/DonationFees.vue')
        },
        {
            name: 'Donations',
            path: 'donations/:type',
            component: () => import('./donations/DonationsPage.vue')
        },
        {
            name: 'Donations Edit',
            path: 'donations/:type/edit/:id',
            component: () => import('./donations/DonationEdit.vue')
        },
        {
            name: 'New Donation Campaign',
            path: 'donations/:type/new',
            component: () => import('./donations/DonationEdit.vue')
        },
        {
            name: 'Medical Notes',
            path: 'medical-notes',
            component: () => import('./medical-notes/MedicalNotes.vue'),
        },
        {
            name: 'Mobile Locations',
            path: 'mobile-locations',
            component: () => import('./mobile-locations/MobileLocations.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Mobile Locations | Create',
            path: 'mobile-locations/create',
            component: () => import('./mobile-locations/MobileLocationsDetails.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Mobile Locations | Edit',
            path: 'mobile-locations/edit/:id',
            component: () => import('./mobile-locations/MobileLocationsDetails.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'OneLink E-Appointments',
            path: 'one-link',
            component: () => import('./one-link/OneLink.vue'),
        },
        {
            name: 'Confirmations & Reminders',
            path: 'reminders/:type',
            component: () => import('./reminders/Reminders.vue'),
            meta: { defaultLayout: true },
        },
        {
            name: 'Confirmations & Reminders | Edit',
            path: 'reminders/edit/:type/:id',
            component: () => import('./reminders/RemindersEdit.vue'),
            meta: { isEditing: true, defaultLayout: false }
        },
        {
            name: 'Confirmations & Reminders | Create',
            path: 'reminders/create/:type',
            component: () => import('./reminders/RemindersEdit.vue'),
            meta: { isEditing: false, defaultLayout: false }
        },
        {
            name: 'Email Attachments',
            path: 'reminders/attachments',
            component: () => import('./reminders/ReminderAttachments.vue'),
        },
        {
            name: 'Subsidies',
            path: 'subsidies',
            component: () => import('./grants/Subsidies.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Subsidy',
            path: 'subsidy/:id?',
            component: () => import('./grants/Subsidy.vue'),
        },
        {
            name: 'Funding Partnerships',
            path: 'partnerships',
            component: () => import('./grants/Partnerships.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Funding Partnership',
            path: 'partnership/:id?',
            component: () => import('./grants/PartnershipEdit.vue'),
        },
        {
            name: 'Grantors',
            path: 'grantors',
            component: () => import('./grants/donors/DonorsPage.vue'),
        },
        {
            name: 'Divvy Setup',
            path: 'divvy-setup',
            component: () => import('./divvy-setup/DivvySetup.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Divvy Setup | Team',
            path: 'divvy-setup/team/:id?',
            component: () => import('./divvy-setup/teams/TeamCreate.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'E-Appointments',
            path: 'online-preferences',
            component: () => import('./online-preferences/OnlinePreferences.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'E-Appointments Edit',
            path: 'online-preferences/edit/:id',
            component: () => import('./online-preferences/OnlinePreferencesEdit.vue')
        },
        {
            name: 'Prescription Labels',
            path: 'prescription-labels',
            component: () => import('./prescription-labels/PrescriptionLabels.vue')
        },
        {
            name: 'Templates',
            path: 'report-templates',
            component: () => import('./templates/Templates.vue')
        },
        {
            name: 'Create Template',
            path: 'report-templates/create',
            component: () => import('./templates/edit/TemplatesEdit.vue'),
        },
        {
            name: 'Edit Template',
            path: 'report-templates/edit/:id',
            component: () => import('./templates/edit/TemplatesEdit.vue'),
        },
        {
            name: 'User Management',
            path: 'user-management',
            component: () => import('./user-management/UserManagement.vue'),
            redirect: '/settings/user-management/users',
            meta: { defaultLayout: true },
            children: [
                {
                    name: 'Users',
                    path: 'users',
                    component: () => import('./user-management/partials/Users.vue'),
                },
                {
                    name: 'Roles',
                    path: 'roles',
                    component: () => import('./user-management/partials/Roles.vue'),
                },
                {
                    name: 'Edit User',
                    path: 'users/edit/:id?',
                    component: () => import('./user-management/partials/UsersEdit.vue'),
                    meta: { defaultLayout: true, isEdit: true }
                },
                {
                    name: 'Edit Role',
                    path: 'roles/edit/:id?',
                    component: () => import('./user-management/partials/RolesEdit.vue'),
                    meta: { defaultLayout: true, isEdit: true }
                }
            ]
        },
        {
            name: 'Wellness',
            path: 'wellness',
            component: () => import('./wellness/WellnessNav.vue'),
            meta: { defaultLayout: true },
            redirect: '/settings/wellness/appointment-types',
            children: [
                {
                    name: 'Appointment Types',
                    path: 'appointment-types',
                    component: () => import('./wellness/appointment-types/AppointmentTypes.vue'),
                },
                {
                    name: 'Rooms',
                    path: 'rooms',
                    component: () => import('./wellness/rooms/Rooms.vue'),
                }
            ]
        },
        {
            name: 'Shelters Addon',
            path: 'shelters-addon',
            component: () => import('./add-ons/shelters/SheltersAddon.vue'),
            redirect: '/settings/shelters-addon/setup',
            children: [
                {
                    name: 'Shelters Setup',
                    path: 'setup',
                    component: () => import('./add-ons/shelters/partials/Addon.vue')
                },
                {
                    name: 'Shelters Vaccines',
                    path: 'vaccines',
                    component: () => import('./add-ons/shelters/partials/Vaccines.vue')
                },
                {
                    name: 'Shelters Breeds',
                    path: 'breeds',
                    component: () => import('./add-ons/shelters/partials/Breeds.vue')
                }
            ]
        },
        {
            name: 'Vets',
            path: 'vets',
            component: () => import('./vets/VetsSettings.vue'),
            meta: { defaultLayout: true },
        },
        {
            name: 'Edit Vet',
            path: 'vets/edit/:id?',
            component: () => import('./vets/edit/VetsEdit.vue'),
            meta: { defaultLayout: true },
        },
        {
            name: 'Vet Schedule',
            path: 'schedule/:type/:id/:title',
            component: () => import('./vets/schedule/VetSchedule.vue')
        },
        {
            name: 'Patient Flow Setup',
            path: 'drug-log',
            meta: { defaultLayout: true },
            component: () => import('./drug-log/DrugLog.vue'),
        },
        {
            name: 'Drug Charts Setup',
            path: 'drug-log/protocols',
            meta: { defaultLayout: true },
            component: () => import('./drug-log/protocols/Protocols.vue')
        },
        {
            name: 'Drug Chart Setup - Protocols',
            path: 'drug-log/protocols/:speciesId/:protocolId?',
            component: () => import('./drug-log/protocols/ProtocolsDetails.vue')
        },
        {
            name: 'Drug Chart Setup - New',
            path: 'drug-log/protocols/:phase/:drugId/create/:speciesId/:protocolId?',
            meta: { isEditing: false, defaultLayout: false },
            component: () => import('./drug-log/protocols/ProtocolsEdit.vue')
        },
        {
            name: 'Drug Chart Setup - Edit',
            path: 'drug-log/protocols/:phase/edit/:id',
            meta: { isEditing: true, defaultLayout: false },
            component: () => import('./drug-log/protocols/ProtocolsEdit.vue')
        },
        {
            name: 'Automations Setup Nav',
            path: 'drug-log/done-actions',
            redirect: '/settings/drug-log/done-actions/patient-flow',
            component: () => import('./drug-log/pf-done-actions/PfDoneActions.vue'),
            children: [
                {
                    name: 'Automations Setup',
                    path: 'patient-flow',
                    component: () => import('./drug-log/pf-done-actions/partials/PatientFlowAutomationMain.vue')
                },
                {
                    name: 'AM Tasks Exclusions',
                    path: 'am-tasks',
                    component: () => import('./drug-log/pf-done-actions/partials/AmTasksExclusions.vue')
                }
            ]
        },
        {
            name: 'Available Drugs Setup',
            path: 'drug-log/other-drugs',
            component: () => import("./drug-log/other-drugs/OtherDrugs.vue")
        },
        {
            name: 'Locked Box Setup',
            path: 'drug-log/locked-boxes',
            component: () => import("./drug-log/locked-boxes/LockedBoxes.vue"),
            meta: { defaultLayout: true }
        },
        {
            name: 'Locked Box Edit',
            path: 'drug-log/locked-boxes/:teamId',
            component: () => import("./drug-log/locked-boxes/LockedBoxesEdit.vue"),
            meta: { defaultLayout: true }
        },
        {
            name: 'Setup Controlled Substances',
            path: 'drug-log/container-logs',
            component: () => import('./drug-log/container-logs/ContainerLogs.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Bottle Logs',
            path: 'drug-log/container-logs/:drugId/bottle',
            component: () => import('./drug-log/container-logs/bottle-logs/BottleLogs.vue'),
            meta: { defaultLayout: true }
        }
    ]
}
